import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/">
            <img src="../img/logo.png" alt="logo" className="logo-img" />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#hotgame" className="page-scroll">
                熱門遊戲
              </a>
            </li>
            <li>
              <a href="#swiper" className="page-scroll">
                精選活動
              </a>
            </li>
            <li>
              <a href="#feature" className="page-scroll">
                六大特色
              </a>
            </li>

            <li>
              <a href="#shortcut" className="page-scroll">
                捷徑教學
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
